/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // if (window.innerWidth <= 750) {
  //     const $container = $('.product__slides'); // <-- adjust to your actual scroll container
  //     const $target = $('.product__slide[data-type="video"]');     
  //     const $video = $target.find('video').get(0);
  //     let alerted = false;
    
  //     function isElementInXView($el, $container) {
  //       const containerLeft = $container.scrollLeft();
  //       const containerRight = containerLeft + $container.outerWidth();
  //       const elLeft = $el.position().left;
  //       const elRight = elLeft + $el.outerWidth();
  //       return elRight > containerLeft && elLeft < containerRight;
  //     }
    
  //     $container.on('scroll', function () {
  //       if (!alerted && isElementInXView($target, $container)) {
  //         alerted = true;
  //         $('.deferred-media__poster').trigger('click');
  //       }
  //     });
    
       
  //     if (isElementInXView($target, $container)) {
  //       alerted = true;   
  //       $('.deferred-media__poster').trigger('click');
  //     }
  //   }
  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();



$(document).ready(function () {
  /*setTimeout(function () {
    if (window.innerWidth <= 750) {
      const $container = $('.product__slides'); // <-- adjust to your actual scroll container
      if($container){
        const $target = $('.product__slide[data-type="video"]');     
        const $video = $target.find('video').get(0);
        let alerted = false;
      
        function isElementInXView($el, $container) {
          const containerLeft = $container.scrollLeft();
          const containerRight = containerLeft + $container.outerWidth();
          const elLeft = $el.position().left;
          const elRight = elLeft + $el.outerWidth();
          return elRight > containerLeft && elLeft < containerRight;
        }
      
        $container.on('scroll', function () {
          if (!alerted && isElementInXView($target, $container)) {
            alerted = true;
            $('.deferred-media__poster').trigger('click');
          }
        });
      
        
        if (isElementInXView($target, $container)) {
          alerted = true;   
          $('.deferred-media__poster').trigger('click');
        }
      }
    }
  }, 1500);*/
  setTimeout(function () {
    if (window.innerWidth <= 750) {
      const $container = $('.product__slides');
      if ($container.length) {
        const $targets = $('.product__slide[data-type="video"]');
        let alertedVideos = new Set();

        function isElementInXView($el, $container) {
          const containerLeft = $container.scrollLeft();
          const containerRight = containerLeft + $container.outerWidth();
          const elLeft = $el.position().left;
          const elRight = elLeft + $el.outerWidth();
          return elRight > containerLeft && elLeft < containerRight;
        }

        function checkAndTriggerVideos() {
          $targets.each(function () {
            const $target = $(this);
            if (!alertedVideos.has(this) && isElementInXView($target, $container)) {
              alertedVideos.add(this);
              $target.find('.deferred-media__poster').trigger('click');
            }
          });
        }

        $container.on('scroll', checkAndTriggerVideos);
        checkAndTriggerVideos(); // Check on load
      }
    }
  }, 1500);

    $('.look__dot__button').on('click', function () {
      // Add 'is-open' class
      $('.look__aside').addClass('is-open');
      
      // Add data-scroll-locked to <html>
      $('html').attr('data-scroll-locked', '');
      
      // Add attributes to <body>
      $('body')
        .attr('data-scroll-lock-locked', 'true')
        .attr('data-scroll-lock-filled-gap', 'true')
        .attr('data-scroll-lock-current-fill-gap-method', 'padding');
    });
    $('.look__actions button').on('click', function () {
      // Add 'is-open' class
      $('.look__aside').addClass('is-open');
      
      // Add data-scroll-locked to <html>
      $('html').attr('data-scroll-locked', '');
      
      // Add attributes to <body>
      $('body')
        .attr('data-scroll-lock-locked', 'true')
        .attr('data-scroll-lock-filled-gap', 'true')
        .attr('data-scroll-lock-current-fill-gap-method', 'padding');
    });
});



/************************/
function filterProductsBySelectedSizes() {


  const urlParams = new URLSearchParams(window.location.search);
  const selectedSizes = urlParams.getAll("filter.v.option.size");

  if (selectedSizes.length === 0) {
    // No filter applied, show all products
    $(".product-item").each(function () {
      if (!$(this).hasClass("product-item--featured-image")) {
        $(this).show();
      }
    });
    return; // Exit early
  }

  const selectedSizesLower = selectedSizes.map(s => s.toLowerCase());

  $(".product-item").each(function () {
    if ($(this).hasClass("product-item--featured-image")) return;

    const availableSizes = $(this).find("ul.size_variants li.available").map(function () {
      return $(this).text().trim().toLowerCase();
    }).get();

    const hasMatchingSize = selectedSizesLower.some(size => availableSizes.includes(size));
    $(this).toggle(hasMatchingSize);
  });
}

$(document).ready(function () {
  filterProductsBySelectedSizes();

  // Bind to sidebar size filter checkbox clicks
  $(".sidebar__item input[type='checkbox']").on("click", function () {
    setTimeout(filterProductsBySelectedSizes, 800);
  });

  // Bind to "active filter remove" button clicks
  $(".active__filters__remove").on("click", function () {
    setTimeout(filterProductsBySelectedSizes, 800);
  });

  // Debounced scroll event
  let scrollTimer;
  $(window).on("scroll", function () {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(filterProductsBySelectedSizes, 500);
  });
});


/*
function filterProductsBySelectedSizes() {
  console.log('hellloooooooooo');
    const urlParams = new URLSearchParams(window.location.search);
    const selectedSizes = urlParams.getAll("filter.v.option.size");
    const selectedSizesLower = selectedSizes.map(s => s.toLowerCase());

    document.querySelectorAll(".product-item").forEach(product => {
        if (product.classList.contains("product-item--featured-image")) return;

        const sizeList = product.querySelectorAll("ul.size_variants li.available");
        const availableSizes = Array.from(sizeList).map(li => li.textContent.trim().toLowerCase());

        const hasMatchingSize = selectedSizesLower.some(size => availableSizes.includes(size));

        product.style.display = hasMatchingSize ? "" : "none";
    });
}
document.addEventListener("DOMContentLoaded", function () {
    filterProductsBySelectedSizes();

    // Bind to sidebar size filter checkbox clicks
    document.querySelectorAll(".sidebar__item input[type='checkbox']").forEach(checkbox => {
        checkbox.addEventListener("click", function () {
            setTimeout(filterProductsBySelectedSizes, 800); // allow AJAX to update
        });
    });

    // Bind to "active filter remove" button clicks
    document.querySelectorAll(".active__filters__remove").forEach(button => {
        button.addEventListener("click", function () {
            setTimeout(filterProductsBySelectedSizes, 800); // allow AJAX to update
        });
    });
    // Scroll event (debounced)
    window.addEventListener("scroll", setTimeout(filterProductsBySelectedSizes, 500));
});

*/
// document.addEventListener('DOMContentLoaded', function () {
//     // Get selected sizes from the URL
//     const urlParams = new URLSearchParams(window.location.search);
//     const selectedSizes = urlParams.getAll("filter.v.option.size");

//     // Convert to lowercase for easier comparison
//     const selectedSizesLower = selectedSizes.map(s => s.toLowerCase());

//     // Loop through each product item
//     document.querySelectorAll(".product-item").forEach(product => {
//         // If the product has `product-item--featured-image`, do NOT hide it
//         if (product.classList.contains("product-item--featured-image")) return;

//         const sizeList = product.querySelectorAll("ul.size_variants li.available");

//         // Get the sizes available for this product
//         const availableSizes = Array.from(sizeList).map(li => li.textContent.trim().toLowerCase());

//         // Check if any selected size exists in available sizes
//         const hasMatchingSize = selectedSizesLower.some(size => availableSizes.includes(size));

//         // Hide the product if no matching sizes found
//         if (!hasMatchingSize) {
//             product.style.display = "none";
//         }
//     });
// });


/*  Confetti effect  ---- Realistic Look
<!-- Include tsParticles Confetti -->
<script src="https://cdn.jsdelivr.net/npm/@tsparticles/confetti@3.0.3/tsparticles.confetti.bundle.min.js"></script>
html 
<button class="confetti-btn2">Celebrate 4🎉</button>  
<canvas id="confetti-canvas"></canvas> 
*/
 document.addEventListener("DOMContentLoaded", () => {
  
      // Confetti burst function
      function launchConfetti() {  
        const defaults = {
          spread: 360,
          ticks: 200,
          gravity: 0.50,
          decay: 0.9,
          startVelocity: 45,
          origin: { y: 0.6 }
        };
    
        function fire(particleRatio, opts) {
          confetti({
            ...defaults,
            ...opts,
            particleCount: Math.floor(200 * particleRatio)
          });
        }
    
        // Realistic effect with multiple bursts
        fire(0.25, {
          spread: 26,
          startVelocity: 55,
        });
    
        fire(0.2, {
          spread: 60,
        });
    
        fire(0.35, {
          spread: 100,
          decay: 0.91,
          scalar: 0.8
        });
    
        fire(0.1, {
          spread: 120,
          startVelocity: 25,
          decay: 0.92,
          scalar: 1.2
        });
    
        fire(0.1, {
          spread: 120,
          startVelocity: 45,
        });
      }

      const now = new Date();  
      // ---- Germany / Austria (CEST UTC+2) ----
      const germanyStart = new Date("2025-07-17T16:00:00Z"); // 6 PM CEST
      const germanyEnd = new Date("2025-07-20T21:59:59Z");   // 11:59 PM CEST  
      // ---- Australia (AEST UTC+10) ----
      const australiaStart = new Date("2025-07-17T08:00:00Z"); // 6 PM AEST
      const australiaEnd = new Date("2025-07-20T13:59:59Z");   // 11:59 PM AEST  
   
      //======== for germany=======
      //if (now >= germanyStart && now <= germanyEnd  && (window.Shopify.country ==='DE' ||  window.Shopify.country === "AT") ){

  
         // launchConfetti();   // when page load 
         /* 
         //at button click 
          document.querySelectorAll(".confetti-btn").forEach(button => {
            button.addEventListener("click", launchConfetti);
          }); 
          // at button touch 
          document.querySelectorAll(".confetti-btn").forEach(button => {
            ebutton.addEventListener("touchstart", launchConfetti);
          }); 
          */
      //======== for germany=======
      // }
 });
/**********************end  Confetti effect  ---- Realistic Look  ****************/


/* *************** 
  // Confetti effect as per client ref 
 //  ref :  https://codepen.io/Franbeltramella/pen/emNdVBP
*/

/*----backup code

 document.addEventListener("DOMContentLoaded", () => {     
  
    const now = new Date();  
    // ---- Germany / Austria (CEST UTC+2) ----
    const germanyStart = new Date("2025-07-17T16:00:00Z"); // 6 PM CEST
    const germanyEnd = new Date("2025-07-20T21:59:59Z");   // 11:59 PM CEST  

   
    //======== for germany=======
    //if (now >= germanyStart && now <= germanyEnd  && (window.Shopify.country ==='DE' ||  window.Shopify.country === "AT") ){


      // JS Confetti Logic
      function initConfetti(canvasId, buttonId) {
        const canvas = document.getElementById(canvasId);
        const ctx = canvas.getContext('2d');
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;      
        let confettis = [];


        if ($(window).width() < 1199) {

          setTimeout(() => {
            const button = document.getElementById(buttonId);
            if (!button) return;
          
            ['click', 'touchstart'].forEach(eventType => {
              button.addEventListener(eventType, (e) => {
                const { x, y, width, height } = e.target.getBoundingClientRect();
                for (let i = 0; i < 75; i++) {
                  confettis.push({
                    x: x + width / 2,
                    y: y + height / 2,
                    dx: (Math.random() - 0.5) * 6,
                    dy: Math.random() * -4 - 2,
                    width: 4,
                    height: 10,
                    angle: Math.random() * 360,
                    rotationSpeed: (Math.random() - 0.5) * 10,
                    color: `hsl(${Math.random() * 360}, 80%, 60%)`,
                    alpha: 1
                  });
                }
              }, { passive: false });
            });
          }, 250);

        
          
        }else{
          document.getElementById(buttonId).addEventListener('click', (e) => {
            const { x, y, width, height } = e.target.getBoundingClientRect();
            for (let i = 0; i < 75; i++) {
              confettis.push({
                x: x + width / 2,
                y: y + height / 2,
                dx: (Math.random() - 0.5) * 6,
                dy: Math.random() * -4 - 2,
                width: 4,
                height: 10,
                angle: Math.random() * 360,
                rotationSpeed: (Math.random() - 0.5) * 10,
                color: `hsl(${Math.random() * 360}, 80%, 60%)`,
                alpha: 1
              });
            }
          });

          document.getElementById(buttonId).addEventListener('mouseenter', (e) => {
            const { x, y, width, height } = e.target.getBoundingClientRect();
            for (let i = 0; i < 75; i++) {
              confettis.push({
                x: x + width / 2,
                y: y + height / 2,
                dx: (Math.random() - 0.5) * 6,
                dy: Math.random() * -4 - 2,
                width: 4,
                height: 10,
                angle: Math.random() * 360,
                rotationSpeed: (Math.random() - 0.5) * 10,
                color: `hsl(${Math.random() * 360}, 80%, 60%)`,
                alpha: 1
              });
            }
          });
        }
        
        function animate() {
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          confettis.forEach((c, i) => {
            c.x += c.dx;
            c.y += c.dy;
            c.dy += 0.2; // gravity
            c.angle += c.rotationSpeed;
            c.alpha -= 0.01;
      
            ctx.save();
            ctx.translate(c.x, c.y);
            ctx.rotate((c.angle * Math.PI) / 180);
            ctx.fillStyle = c.color;
            ctx.globalAlpha = c.alpha;
            ctx.fillRect(-c.width / 2, -c.height / 2, c.width, c.height);
            ctx.restore();
      
            if (c.alpha <= 0) confettis.splice(i, 1);
          });
          requestAnimationFrame(animate);
        }
        animate();
      }
      
      // Initialize both product and cart confetti effects
      initConfetti('confetti-canvas-product', 'confetti-canvas-product-btn');
      initConfetti('confetti-canvas-cart', 'confetti-canvas-cart-btn');


    //======== for germany=======
    // }
   
});
end -- backup code *************/

document.addEventListener("DOMContentLoaded", () => {
  
    const now = new Date();  
    // ---- Germany / Austria (CEST UTC+2) ----
   // const germanyStart = new Date("2025-07-17T07:58:00Z"); //9:50 AM Germany time = 7:50 AM UTC
    //const germanyLocalTime = germanyStart.toLocaleString("de-DE", {  timeZone: "Europe/Berlin",  dateStyle: "short",  timeStyle: "short"});
  
    const germanyStart = new Date("2025-07-17T16:00:00Z"); // 6 PM CEST
    const germanyEnd = new Date("2025-07-20T21:59:59Z");   // 11:59 PM CEST  
  
    function initConfetti(canvasId, buttonId) {
      const canvas = document.getElementById(canvasId);
      const button = document.getElementById(buttonId);
      if (!canvas || !button) return; // ⛔ Skip if not found

      const ctx = canvas.getContext('2d');
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;

      let confettis = [];

      const triggerConfetti = (e) => {
        const { x, y, width, height } = e.target.getBoundingClientRect();
        for (let i = 0; i < 75; i++) {
          confettis.push({
            x: x + width / 2,
            y: y + height / 2,
            dx: (Math.random() - 0.5) * 6,
            dy: Math.random() * -4 - 2,
            width: 4,
            height: 10,
            angle: Math.random() * 360,
            rotationSpeed: (Math.random() - 0.5) * 10,
            color: `hsl(${Math.random() * 360}, 80%, 60%)`,
            alpha: 1
          });
        }
      };

      if (window.innerWidth < 1199) {
        ['click', 'touchstart'].forEach(eventType =>
          button.addEventListener(eventType, triggerConfetti, { passive: false })
        );
      } else {
        button.addEventListener('click', triggerConfetti);
        button.addEventListener('mouseenter', triggerConfetti);
      }

      function animate() {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        confettis.forEach((c, i) => {
          c.x += c.dx;
          c.y += c.dy;
          c.dy += 0.2;
          c.angle += c.rotationSpeed;
          c.alpha -= 0.01;

          ctx.save();
          ctx.translate(c.x, c.y);
          ctx.rotate((c.angle * Math.PI) / 180);
          ctx.fillStyle = c.color;
          ctx.globalAlpha = c.alpha;
          ctx.fillRect(-c.width / 2, -c.height / 2, c.width, c.height);
          ctx.restore();

          if (c.alpha <= 0) confettis.splice(i, 1);
        });
        requestAnimationFrame(animate);
      }
      animate();
    }

    //======== for germany=======
    if (now >= germanyStart && now <= germanyEnd  && (window.Shopify.country ==='DE' ||  window.Shopify.country === "AT") ){
      /*
        $(".button-canvas-wrapper").show();
      // 🛡️ Only initialize if the elements exist
      if (document.getElementById('confetti-canvas-product') && document.getElementById('confetti-canvas-product-btn')) {
         initConfetti('confetti-canvas-product', 'confetti-canvas-product-btn');
      }

      if (document.getElementById('confetti-canvas-cart') && document.getElementById('confetti-canvas-cart-btn')) {
        initConfetti('confetti-canvas-cart', 'confetti-canvas-cart-btn');
      }

*/
      /****cart drawer free shiiping text modify*/
     /*
     const cartDrawer = document.getElementById('cart-drawer');
      
        function updateShippingText() {
          const shippingValues = cartDrawer.querySelectorAll('.cart__item-shipping-value');
          shippingValues.forEach(function (el) {
            el.textContent = 'Kostenlos';
          });
        }
      
        // Run once on initial page load in case drawer is already open
        if (cartDrawer.classList.contains('is-open')) {
          updateShippingText();
        }
      
        // Observe for class changes (to detect drawer opening)
        const observer = new MutationObserver(function (mutationsList) {
          for (const mutation of mutationsList) {
            if (
              mutation.type === 'attributes' &&
              mutation.attributeName === 'class'
            ) {
              if (cartDrawer.classList.contains('is-open')) {
                // Drawer just opened
                updateShippingText();
              }
            }
          }
        });
      
        observer.observe(cartDrawer, { attributes: true });
*/
      

    //======== for germany=======
     }else{
        $(".button-canvas-wrapper").hide();
     }
});

/********************* end Confetti effect as per client ref  ********************/

/**************Shoplooog image slider************* */
$(document).on('click','.look__dot__button', function(e) {
	e.preventDefault();
	 // Only run on desktop (screen width above 750px)
    //if (window.innerWidth > 750){

      const sliderThumb = this.getAttribute('data-slider-thumb');
      const targetSlide = document.querySelector(`.look__slide[data-slide-index="${sliderThumb}"]`);
      const sliderContainer = document.querySelector('.look__slider');
      console.log(sliderThumb);
       console.log(targetSlide);
       console.log(sliderContainer);
  
      if (targetSlide && sliderContainer) {
        // Scroll the slider to the target slide
        sliderContainer.scrollTo({
          left: targetSlide.offsetLeft,
          behavior: 'smooth'
        });
  
        // Remove 'active' class from all slides
        document.querySelectorAll('.look__slide').forEach(slide => {
          slide.classList.remove('active');
        });
  
        // Add 'active' class to the target slide
        targetSlide.classList.add('active');
      }
    //}
});




/*jQuery(document).ready(function(){
  gsap.registerPlugin(ScrollTrigger);
  const details = gsap.utils.toArray(".content:not(:first-child)");
  const photos = gsap.utils.toArray(".image:not(:first-child)");
  gsap.set(photos, { yPercent: 101 });

  ScrollTrigger.create({
    trigger: ".main-wrap",
    start: "top top",
    end: "bottom bottom",
    pin: ".right-side",
    markers: false,
  });

  details.forEach((detail, index) => {
    let headline = detail.querySelector(".content-desc");
    ScrollTrigger.create({
      trigger: headline,
      start: "top 80%",
      end: "bottom 70%",
      animation: gsap.to(photos[index], { yPercent: 0 }),
      scrub: true,
      markers: false,
    });
  });
});*/

let swiperInstance;
  function initSwiper() {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    if (swiperInstance) swiperInstance.destroy(true, true);

  //   swiperInstance = new Swiper(".shoplook-image_slider", {
  //       slidesPerView: 3,
  //       spaceBetween: 32,
  //       centeredSlides: true,
  //       loop: true,
  //       pagination: {
  //         el: ".swiper-pagination",
  //         clickable: true,
  //       },
  //       navigation: {
  //        nextEl: '.swiper-button-next',
  //        prevEl: '.swiper-button-prev',
  //      },
  //      autoplay: {
  //       delay: 5000, // Time between slides in ms (3000 = 3 seconds)
  //       disableOnInteraction: false, // Keep autoplay running after user interacts
  //     },
  //    breakpoints: {
  //         0: {
  //           slidesPerView: 1,
  //           spaceBetween: 0,
  //           centeredSlides: true,
  //         },
  //         750: {
  //           slidesPerView: 3,
  //           spaceBetween: 16,
  //         },
  //         990: {
  //           spaceBetween: 22,
  //         }
  //     }
  //  });

  var swiper = new Swiper(".shoplook-image_slider", {
  effect: "coverflow",
  grabCursor: true,
  centeredSlides: true,
  coverflowEffect: {
    rotate: 0,
    stretch: 238,
    depth: 100,
    modifier: 1,
    slideShadows: false
  },
  loop: true,
  // Navigation arrows
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev"
  },
    pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    750: {
      spaceBetween: 20,
      slidesPerView: 1.5,
      effect: "slide"
    },
    1024: {
      spaceBetween: 22,
      slidesPerView:3,
      effect: "slide"
    }
  }
});


    // Restore scroll position to prevent jump
    window.scrollTo({
      top: scrollTop,
      behavior: 'instant' // prevents flicker
    });
  }
document.addEventListener('DOMContentLoaded', initSwiper);

  // Re-init Swiper after section is loaded or reordered
  const events = [
    'shopify:section:load',
    'shopify:section:reorder',
    'shopify:section:select',
    'shopify:block:select',
    'shopify:block:deselect'
  ];

  events.forEach(eventName => {
    document.addEventListener(eventName, () => {
      requestAnimationFrame(() => {
        initSwiper();
      });
    });
  });
  /*******************shop look image slider************ */

/* Fix: theme.js only writes input[name="id"] when a variant option's native
   "change" event fires and that one-time listener runs successfully; the
   add-to-cart handler (CartItems.cartAddEvent) then trusts whatever value is
   already sitting in that hidden field, with no re-check against what's
   actually selected. If the change listener ever misses a click (an error
   thrown earlier in the same task by another script, a DOM node swap that
   drops the listener, etc.), the wrong variant silently gets added to cart -
   this happened with a customer picking one size and a different size
   landing in the cart. Recompute the intended variant from the currently
   checked/selected option inputs and correct the hidden id field, in the
   capture phase so this runs before theme.js's own bubble-phase handler
   reads the form.

   Two DOM patterns exist for this theme's product forms, and both need
   handling: input[name="id"] and the options[...] radios are NOT nested
   inside the <form> element - they're linked via the HTML form="..."
   attribute instead (on the main PDP AND inside quick-add/upsell modals).
   form.querySelector('input[name="id"]') silently finds nothing in that
   pattern, so this uses form.elements (which resolves form="..."
   associations the same as native nesting) and searches the whole
   section container for the option inputs, not just inside the <form>
   tag. That container is found via Shopify's own auto-generated
   [id^="shopify-section-"] wrapper (present on every section render,
   including ones fetched through the Section Rendering API) rather than
   any theme-specific attribute - the theme's own data-section-type is
   NOT an ancestor of data-product-json on the main PDP (verified via a
   jsdom test against the live markup), which silently broke the very
   first version of this fix there. */
function getSelectedOptionValue(container, optionName) {
  const prefix = 'options[' + optionName + ']';
  const els = container.querySelectorAll('[name^="' + CSS.escape(prefix) + '"]');
  for (const el of els) {
    if (el.tagName === 'SELECT') return el.value;
    if ((el.type === 'radio' || el.type === 'checkbox') && el.checked) return el.value;
  }
  return null;
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-add-to-cart], [data-add-to-cart-bar]');
  if (!trigger) return;

  const container = trigger.closest('[id^="shopify-section-"]') || document;
  const form = container.querySelector('[data-product-form]');
  if (!form) return;

  const idField = form.elements['id'];
  if (!idField) return;
  const idNodes = idField instanceof RadioNodeList ? Array.from(idField) : [idField];

  const jsonScript = container.querySelector('[data-product-json]');
  if (!jsonScript) return;

  let product;
  try {
    product = JSON.parse(jsonScript.textContent);
  } catch (e) {
    return;
  }
  if (!product.options || !product.options.length) return;

  const selections = product.options.map((optionName) => getSelectedOptionValue(container, optionName));
  if (selections.some((value) => value === null)) return;

  const matchedVariant = product.variants.find((variant) =>
    variant.options.every((value, i) => value === selections[i])
  );

  if (matchedVariant && String(matchedVariant.id) !== String(idNodes[0].value)) {
    console.warn('Variant id mismatch corrected before add-to-cart', {
      wasId: idNodes[0].value,
      correctedId: matchedVariant.id,
      selections
    });
    idNodes.forEach((node) => {
      node.value = matchedVariant.id;
    });
  }
}, true);


